import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import { useT } from "../../stores/uiLang";
import { PE_T } from "../../i18n/peLesson";

import { Header } from "../sections/Header";
import CookieConsentBanner from "../CookieConsentBanner";

export function DefaultLayout() {
  // Run E2 J5: the toast region's screen-reader label follows the UI language.
  const t = useT(PE_T);
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <ToastContainer aria-label={t.notificationsAria} />
      {/* Render child routes */}
      <main className="max-w-[95rem] mx-auto pb-6 pt-[80px] sm:px-6 lg:px-8">
        <Outlet />
      </main>
      <CookieConsentBanner />
    </div>
  );
}
